var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCnc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#695346",
    d: "M3.5 2a.5.5 0 0 0-.5.5V5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2.5a.5.5 0 0 0-.5-.5zm7 8h4A1.5 1.5 0 0 0 16 8.5V8H4v.5A1.5 1.5 0 0 0 5.5 10h4v2.5a.5.5 0 0 0 1 0zM5 14.5a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 0 1H5.5a.5.5 0 0 1-.5-.5m8-.5a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1zm-2.5.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0m0 2a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0zm-1.646-1.354a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0m2.292.708a.5.5 0 0 1 .708-.708l1.5 1.5a.5.5 0 0 1-.708.708z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnc);
export default __webpack_public_path__ + "static/media/cnc.d82e8d42b5ad7e610ff1ba8f9b968bcc.svg";
export { ForwardRef as ReactComponent };